// QUIÉN ATIENDE CADA LÍNEA EN MI BOOKING LINK (Lissette 2026-10-17).
//
// "Un toggle de todas las personas de la agencia, agente y seat", y que sea
// por tipo de póliza: "Medicare no es para todo el mundo, pero dental o salud
// sí… no todos los seat pueden atender Medicare".
//
// Por cada línea del enlace (o una sola fila, "Todas las citas", si el enlace
// no trabaja por líneas) se encienden las personas que la atienden. El cliente
// ve una hora si al menos una de ellas está libre, y la cita queda para una de
// las libres. Sin nadie encendido, la cita es con la dueña del enlace, como
// siempre. El servidor decide con deskte-api/src/utils/equipoDelEnlace.ts.
import React from "react";
import { LINEAS_DE_BLOQUEO } from "../lineasDeBloqueo.js";
import { TODAS, personasEncendidas, alternarPersona, conHorarioPropio, sinHorarioPropio, cambiarDiaPropio, DIAS_SEMANA, franjasDelDia, cambiarFranja, agregarFranja, quitarFranja } from "../equipoDelEnlace.js";

export default function EquipoDelEnlace({ cfg, setField, users, lang, yo }) {
  const es = lang === "es";
  const tt = (a, b) => (es ? a : b);
  const duena = cfg.userId;
  const gente = (users || []).filter((u) => u && u.id && u.isActive !== false);
  if (duena && !gente.some((u) => u.id === duena)) gente.unshift({ id: duena, name: tt("Yo", "Me") });
  const filas = (cfg.lineas || []).length
    ? LINEAS_DE_BLOQUEO.filter((l) => cfg.lineas.includes(l.id)).map((l) => ({ clave: l.id, nombre: es ? l.es : l.en }))
    : [{ clave: TODAS, nombre: tt("Todas las citas", "All appointments") }];
  const lbl = { fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".4rem" };

  if (gente.length < 2) return null; // sola en la agencia: no hay a quién elegir

  return (
    <div>
      <div style={lbl}>👥 {tt("¿Quién atiende las citas de este enlace?", "Who takes this link's appointments?")}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: ".45rem" }}>
        {filas.map(({ clave, nombre }) => {
          const encendidas = personasEncendidas(cfg.equipo, clave, duena);
          return (
            <div key={clave} style={{ display: "flex", alignItems: "center", gap: ".5rem", flexWrap: "wrap" }}>
              <span style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", minWidth: 120 }}>{nombre}</span>
              {gente.map((u) => {
                const on = encendidas.includes(u.id);
                return (
                  <button key={u.id} type="button" role="switch" aria-checked={on}
                    onClick={() => setField({ equipo: alternarPersona(cfg.equipo, clave, u.id, duena) })}
                    style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: ".7rem", fontWeight: 700, padding: ".25rem .6rem", borderRadius: 100, cursor: "pointer", fontFamily: "inherit",
                      border: `1px solid ${on ? "var(--c-cyan,#00d4ff)" : "var(--c-border,#1a3550)"}`,
                      background: on ? "rgba(0,212,255,.14)" : "transparent", color: on ? "var(--c-cyan,#00d4ff)" : "var(--c-text2,#7aa3c0)" }}>
                    <span style={{ width: 22, height: 12, borderRadius: 6, background: on ? "var(--c-cyan,#00d4ff)" : "var(--c-surface3,#162d44)", position: "relative", flexShrink: 0 }}>
                      <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#fff", position: "absolute", top: 2, left: on ? 12 : 2, transition: "left .2s" }} />
                    </span>
                    {u.name || u.email || u.id}{u.id === duena ? ` (${!yo || yo === duena ? tt("tú", "you") : tt("dueño del enlace", "link owner")})` : ""}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4 }}>
        {tt("El cliente ve una hora si al menos una de las personas encendidas está libre, y la cita queda para una de ellas (se reparten parejo). Si no enciendes a nadie más, las citas son contigo.",
            "The client sees a time if at least one of the people switched on is free, and the appointment goes to one of them (shared out evenly). If you switch on no one else, appointments are with you.")}
      </div>
      <HorariosPropios cfg={cfg} setField={setField} gente={gente} filas={filas} duena={duena} es={es} yo={yo} />
    </div>
  );
}

// HORARIO PROPIO POR PERSONA (Lissette 2026-10-17): "si yo no puedo atender en
// la mañana pero Victor sí". Solo para quien está encendido en alguna fila.
// Recorta el horario del enlace; sin horario propio, vale el del enlace.
function HorariosPropios({ cfg, setField, gente, filas, duena, es, yo }) {
  const tt = (a, b) => (es ? a : b);
  const encendidos = new Set(filas.flatMap(({ clave }) => personasEncendidas(cfg.equipo, clave, duena)));
  const personas = gente.filter((u) => encendidos.has(u.id));
  if (personas.length < 2) return null; // con una sola persona, el horario del enlace ya es el suyo
  const horarios = cfg.horarios || {};
  const NOMBRES = es
    ? { mon: "Lun", tue: "Mar", wed: "Mié", thu: "Jue", fri: "Vie", sat: "Sáb", sun: "Dom" }
    : { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" };
  const chico = { fontSize: ".68rem", width: 118 };
  return (
    <div style={{ marginTop: ".7rem" }}>
      <div style={{ fontSize: ".65rem", color: "var(--c-text3,#45688a)", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: ".35rem" }}>
        🕘 {tt("Horario de cada persona", "Each person's hours")}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
        {personas.map((u) => {
          const h = horarios[u.id];
          const nombre = (u.name || u.email || u.id) + (u.id === duena ? ` (${!yo || yo === duena ? tt("tú", "you") : tt("dueño del enlace", "link owner")})` : "");
          return (
            <div key={u.id} style={{ border: "1px solid var(--c-border,#1a3550)", borderRadius: 9, padding: ".45rem .6rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: ".6rem", flexWrap: "wrap" }}>
                <span style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--c-white,#eef6ff)", minWidth: 140 }}>{nombre}</span>
                {h
                  ? <button type="button" className="dkt-btn-s" onClick={() => setField({ horarios: sinHorarioPropio(horarios, u.id) })} style={{ fontSize: ".66rem", padding: ".2rem .55rem" }}>{tt("Usar el horario del enlace", "Use the link's hours")}</button>
                  : <>
                      <span style={{ fontSize: ".66rem", color: "var(--c-text3,#45688a)" }}>{tt("Usa el horario del enlace", "Uses the link's hours")}</span>
                      <button type="button" className="dkt-btn-s" onClick={() => setField({ horarios: conHorarioPropio(horarios, u.id, cfg.availability) })} style={{ fontSize: ".66rem", padding: ".2rem .55rem" }}>🕘 {tt("Horario propio", "Own hours")}</button>
                    </>}
              </div>
              {h && (
                <div style={{ display: "flex", flexDirection: "column", gap: 3, marginTop: ".4rem" }}>
                  {DIAS_SEMANA.map((d) => {
                    const dia = h[d] || { active: false };
                    const franjas = franjasDelDia(dia);
                    const delEnlace = cfg.availability?.[d];
                    const cerradoEnElEnlace = !delEnlace?.active;
                    const abierto = !!dia.active && !cerradoEnElEnlace;
                    return (
                      <div key={d} style={{ display: "flex", alignItems: "flex-start", gap: ".45rem", opacity: cerradoEnElEnlace ? .5 : 1 }}>
                        <button type="button" role="switch" aria-checked={abierto} disabled={cerradoEnElEnlace}
                          onClick={() => setField({ horarios: dia.active
                            ? cambiarDiaPropio(horarios, u.id, d, { active: false })
                            : (franjas.length ? cambiarDiaPropio(horarios, u.id, d, { active: true }) : agregarFranja(horarios, u.id, d)) })}
                          style={{ width: 28, height: 16, marginTop: 6, borderRadius: 8, border: "none", cursor: cerradoEnElEnlace ? "not-allowed" : "pointer", background: abierto ? "var(--c-cyan,#00d4ff)" : "var(--c-surface3,#162d44)", position: "relative", flexShrink: 0 }}>
                          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, left: abierto ? 15 : 3 }} />
                        </button>
                        <span style={{ fontSize: ".68rem", width: 34, marginTop: 6, color: "var(--c-text2,#7aa3c0)" }}>{NOMBRES[d]}</span>
                        {cerradoEnElEnlace
                          ? <span style={{ fontSize: ".64rem", marginTop: 6, color: "var(--c-text3,#45688a)" }}>{tt("Cerrado en el enlace", "Closed on the link")}</span>
                          : abierto && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: ".35rem .8rem", alignItems: "center" }}>
                              {franjas.map((f, i) => (
                                <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: ".3rem" }}>
                                  <input type="time" className="dkt-inp" value={f.start} onChange={(e) => setField({ horarios: cambiarFranja(horarios, u.id, d, i, { start: e.target.value }) })} style={chico} />
                                  <span style={{ color: "var(--c-text3,#45688a)", fontSize: ".66rem" }}>→</span>
                                  <input type="time" className="dkt-inp" value={f.end} onChange={(e) => setField({ horarios: cambiarFranja(horarios, u.id, d, i, { end: e.target.value }) })} style={chico} />
                                  <button type="button" onClick={() => setField({ horarios: quitarFranja(horarios, u.id, d, i) })} title={tt("Quitar este horario", "Remove this time range")}
                                    style={{ background: "none", border: "none", color: "var(--c-text3,#45688a)", cursor: "pointer", fontSize: ".8rem", padding: 0 }}>✕</button>
                                </span>
                              ))}
                              <button type="button" onClick={() => setField({ horarios: agregarFranja(horarios, u.id, d) })}
                                style={{ background: "none", border: "1px dashed var(--c-border,#1a3550)", color: "var(--c-cyan,#00d4ff)", cursor: "pointer", fontSize: ".66rem", fontWeight: 700, padding: ".2rem .5rem", borderRadius: 7, fontFamily: "inherit" }}>
                                + {tt("Otro horario", "Another time range")}
                              </button>
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4 }}>
        {tt("Puedes poner varios horarios en el mismo día (ej. 9–11, 2–4 y 6–9): el espacio entre uno y otro es su descanso. El horario propio solo achica el del enlace: un día u hora cerrados en el enlace están cerrados para todos. Los días bloqueados, el descanso y el tiempo entre citas del enlace valen para todos. Pulsa Guardar arriba.",
            "You can set several time ranges on the same day (e.g. 9–11, 2–4 and 6–9): the gap between them is their break. Own hours can only narrow the link's hours: a day or time closed on the link is closed for everyone. The link's blocked days, break and time between appointments apply to everyone. Hit Save above.")}
      </div>
    </div>
  );
}
